import "./getRequestService";
import "./getRequestInterceptor";
import angular from "angular";
angular.module('clientDashboardApp.httpUtil', [
  'clientDashboardApp.httpUtil.getRequestInterceptor',
  'clientDashboardApp.httpUtil.getRequestService'
]);
